import angular from 'angular';
import FancyCurrencyDirective from './fancy-currency/ws-fancy-currency';
import FancyPercentDirective from './fancy-percent/ws-fancy-percent';

const injectorName = 'ws.common.formatting';
export default injectorName;

angular.module(injectorName, [])
  .directive('wsFancyCurrency', FancyCurrencyDirective)
  .directive('wsFancyPercent', FancyPercentDirective);



// WEBPACK FOOTER //
// ./src/formatting/index.js